const Raptor = Mach.requireModule('Raptor');

export class AddressMonitor {
  /**
     * 通参
     */
  defaultTags = {
    osName: Mach.env.osName ?? '',
    osVersion: Mach.env.osVersion ?? '',
    appVersion: Mach.env.version ?? '',
    platform: Mach.env.isAndroid ? 'Android' : 'iOS',
    bundleVersion: Mach.env.bundleVersion ?? '',
    bundleName: Mach.env.bundleName ?? '',
  }

  reportToReport = (value: number, values = {}) => {
    const tags = { ...this.defaultTags, ...values, status: value };
    this.reportMetrics({ ChangeLocationPage: value }, tags);
  }

  reportOpenCityRequestToReport = (value: number, values = {}) => {
    const tags = { ...this.defaultTags, ...values, status: value };
    this.reportMetrics({ OpenCityRequest: value }, tags);
  }

  reportOpenCityResponseToReport = (value: number, values = {}) => {
    const tags = { ...this.defaultTags, ...values, status: value };
    this.reportMetrics({ OpenCityReponse: value }, tags);
  }

  reportAddressSchemaInfo = (value: number, params = {}) => {
    const tags = { ...this.defaultTags, ...params, status: value };
    this.reportMetrics({ AddressSchemaInfo: value }, tags);
  }

  reportChangeRegionFailedCount = (value: number, values = {}) => {
    const tags = { ...this.defaultTags, ...values, status: value };
    this.reportMetrics({ ChangeRegionFailedCount: value }, tags);
  }

  reportChangeRegionAndLanguage = (value: number, params = {}) => {
    const tags = { ...this.defaultTags, ...params, status: value };
    this.reportMetrics({ ChangeRegionAndLanguage: value }, tags);
  }

  reportAddressExtra = (value: number, params = {}) => {
    const tags = { ...this.defaultTags, ...params, status: value };
    this.reportMetrics({ SLAddressExtra: value }, tags);
  }

  reportMissNameParam = (value: number, params = {}) => {
    const tags = { ...this.defaultTags, ...params, status: value };
    this.reportMetrics({ SLAddressSaveNameIsNull: value }, tags);
  }

  reportMetrics = (params, tags) => {
    const envName = Mach.env.isDebug ? 'Test' : 'Prod';
    const tagsObj = { ...tags, env: envName };
    // 校验tag数据是否为字符串
    const tagParams = this.checkAndConvertToString(tagsObj);
    Raptor?.reportMetrics?.(params, tagParams, 1.0);
  }

  reportAddressSaveParams = (value: number, params = {}) => {
    const tags = { ...this.defaultTags, ...params, status: value };
    this.reportMetrics({ SLAddressSaveParams: value }, tags);
  }

  /**
     * 检查Value类型是否为字符串并转换
     * @param obj
     * @returns
     */
  checkAndConvertToString = (obj) => {
    if (Array.isArray(obj) || typeof obj !== 'object') {
      return obj;
    }
    const convertObj = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (typeof obj[key] === 'string') {
          convertObj[key] = obj[key];
        } else if (typeof obj[key] === 'number') {
          convertObj[key] = String(obj[key]);
        }
      }
    }
    return convertObj;
  }
}
